import React from 'react';
import Overlay from '../../content/images/PreviewOverlayV6.png';
import FrenchOverlay from '../../content/images/PreviewOverlayFrench.png';
import css from './PreviewOverlay.module.scss';


export interface IProps {
    locale: string;
}

const PreviewOverlay = (props: IProps) => {
    let overlay = Overlay;
    let altText = 'Preview Mode Overlay';

    if (props.locale === 'fr-CA') {
        overlay = FrenchOverlay;
        altText = 'Mode Aperçu';
    }

    return (
        <div className={css.previewOverlay}>
            <img src={overlay} className={css.previewImg} alt={altText} />
        </div>
    );
};

export default PreviewOverlay;
